export default __webpack_public_path__ + "static/media/landing-instagram-icon.4669b99a.svg";